import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../../../../services/util.service';
import { ErrorService } from '../../../../../services/error.service';
import { API, TemplateDataSetDTO, TemplateDataSetEntryDTO } from '../../../../../services/api/api';
import { ModalNavigationService } from '../../../../../services/gui/modal/modal-navigation.service';
import { TableWrapperOptions } from '../../../../../services/global/global-interfaces';

@Component({
  selector: 'sb-template-data-set-select-modal',
  templateUrl: './sb-template-data-set-select-modal.component.html',
  styleUrls: ['./sb-template-data-set-select-modal.component.scss'],
  standalone: false,
})
export class SbTemplateDataSetSelectModalComponent implements OnInit {
  public loading: boolean;
  public options: TableWrapperOptions;
  public optionsEntries: TableWrapperOptions;
  public templateDatasets: TemplateDataSetDTO[];

  debounceTimer: ReturnType<typeof setTimeout> = null;
  private templateGroupID: number;
  showDataset: boolean;
  templateDatasetEntries: TemplateDataSetEntryDTO[];
  selectedDataSet: TemplateDataSetDTO | null;

  constructor(
    private readonly api: API,
    private readonly util: UtilService,
    private readonly errorService: ErrorService,
    private readonly modalNavigation: ModalNavigationService
  ) {
    this.selectedDataSet = null;
    this.templateDatasetEntries = [];
    this.showDataset = true;
    this.loading = true;
    this.templateGroupID = -1;
    this.templateDatasets = [];
  }

  public ngOnInit(): void {
    this.templateGroupID = Number(this.modalNavigation.getCurrentNavigation().data?.templateGroupID);
  }

  public refreshFromServer() {
    this.loading = true;
    const groupIds: number[] = [];
    if (!isNaN(this.templateGroupID)) {
      groupIds.push(this.templateGroupID);
    }
    this.api
      .mm_templating_advertiser_TemplateDataSet_retrieveAll(
        {
          group_ids: groupIds,
          search: this.util.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
        },
        this.options.pagination
      )
      .subscribe({
        next: (templateDatasets: TemplateDataSetDTO[]) => {
          this.templateDatasets = templateDatasets;
          this.loading = false;
        },
        error: error => {
          this.errorService.errorHandler(error);
        },
      });
  }

  public requestDebounced(options?: TableWrapperOptions): void {
    if (options) {
      this.options = options;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  public selectTemplateDataset(pTemplateDataset: TemplateDataSetDTO): void {
    if (pTemplateDataset) {
      this.modalNavigation.result({ templateDataset: pTemplateDataset, templateDatasetEntry: null });
    }
  }

  public cancel(): void {
    this.modalNavigation.result(undefined);
  }

  showDatasetEntries(templateDataset: TemplateDataSetDTO) {
    // first select then display entries due to timed calls of table wrapper
    this.selectedDataSet = templateDataset;
    this.showDataset = false;
  }

  public refreshFromServerEntries() {
    this.loading = true;
    this.api
      .mm_templating_advertiser_TemplateDataSetEntry_retrieveAll(
        this.selectedDataSet.id,
        {
          search: this.util.encodeSearchQueryParam(this.optionsEntries.exactMatch, this.optionsEntries.search),
        },
        this.optionsEntries.pagination
      )
      .subscribe({
        next: (templateDatasetEntries: TemplateDataSetEntryDTO[]) => {
          this.templateDatasetEntries = templateDatasetEntries;
          this.loading = false;
        },
        error: error => {
          this.errorService.errorHandler(error);
        },
      });
  }

  public requestDebouncedEntries(options?: TableWrapperOptions): void {
    if (options) {
      this.optionsEntries = options;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServerEntries();
    }, 500);
  }

  selectTemplateDatasetEntry(pTemplateDatasetEntry: TemplateDataSetEntryDTO) {
    if (pTemplateDatasetEntry) {
      this.modalNavigation.result({ templateDataset: this.selectedDataSet, templateDatasetEntry: pTemplateDatasetEntry });
    }
  }
}
